import React from 'react';
import { Container, Link, Theme, Typography } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { Link as RouterLink } from 'react-router-dom';

import { Footer } from '@bizapp-lp/home/organisms/Footer';
import { Header } from '@bizapp-lp/home/templates/Header';

interface CompleteStyleProps {
  withChildren?: boolean;
}

const useStyle = makeStyles<Theme, CompleteStyleProps>((theme: Theme) =>
  createStyles({
    root: {
      backgroundColor: '#ffffff',
      textAlign: 'center',
    },
    header: {
      padding: theme.spacing(5, 2),
      backgroundColor: '#F2F3FB',
    },
    message: {
      padding: theme.spacing(5, 2, 0),
      textAlign: 'center',
      '& .MuiTypography-h2': {
        color: '#0E9499',
      },
      '& p': {
        margin: theme.spacing(3, 'auto', 5),
        maxWidth: '420px',
      },
    },
    link: (props: CompleteStyleProps) => ({
      display: 'block',
      margin: props.withChildren
        ? theme.spacing(10, 'auto', 8)
        : theme.spacing(0, 'auto', 20),
      color: '#1565C0',
      fontSize: '14px',
      lineHeight: '21px',
      fontWeight: 'normal',
    }),
  }),
);

export interface CompleteProps {
  className?: string;
  heading1?: string | JSX.Element;
  heading2?: string | JSX.Element;
  description?: string | JSX.Element;
  children?: string | JSX.Element | JSX.Element[];
}

export const Complete: React.FC<CompleteProps> = ({
  className,
  heading1,
  heading2,
  description,
  children,
}: CompleteProps) => {
  const classes = useStyle({ withChildren: !!children });
  return (
    <>
      <Header disableButton />
      <Container
        disableGutters
        maxWidth={false}
        className={`${classes.root} ${className ?? ''}`}
      >
        <Container
          component="header"
          disableGutters
          maxWidth={false}
          className={classes.header}
        >
          <Typography variant="h1">{heading1}</Typography>
        </Container>
        <Container
          component="section"
          disableGutters
          maxWidth={false}
          className={classes.message}
        >
          <Typography variant="h2">{heading2}</Typography>
          <Typography variant="body1">{description}</Typography>
        </Container>
        {children}
        <Link className={classes.link} component={RouterLink} to="/">
          TOPページへ戻る
        </Link>
      </Container>
      <Footer />
    </>
  );
};
